import { CompRef, DocumentServicesObject } from '@wix/document-services-types';

export const getPrimaryConnectionsWithRefs = (
  documentServicesAPI: DocumentServicesObject,
  widgetRef: CompRef,
) =>
  documentServicesAPI.platform.controllers.connections
    .getConnectedComponents(widgetRef, true)
    .map((compRef) => {
      const primaryConnection =
        documentServicesAPI.platform.controllers.connections.getPrimaryConnection(
          compRef,
        );

      return { ...primaryConnection, compRef };
    });
